<template>
  <div v-if="value">
    <v-chip 
      v-for="tag in value.split(separator)" 
      :key="tag.$index" 
      x-small 
      class="mr-1" 
      :style="`background-color: #`+ tag + (50+parseInt(tag)) + tag"
      text-color="white"
    >
      {{ tag }}
    </v-chip>
  </div>
</template>

<script>
export default {
	name: "AppChips",
	props: {
    value: {
      type: String,
      default: ""
    },
    separator: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
</style>